
import Kanban from "../../../assets/filled/Kanban.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KanbanIcon({ className, dataTestid = "KanbanIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Kanban data-testid={dataTestid} className={classes} {...rest} />
  );
}
